export default __webpack_public_path__ + "static/media/x-button.f939aa43.svg";